import script from "./SideBarDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarDefault.vue?vue&type=script&setup=true&lang=js"

import "./SideBarDefault.vue?vue&type=style&index=0&id=302d5c39&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-302d5c39"]])

export default __exports__